import { Skeleton, Upload, Select, notification } from 'antd';
import { ButtonAction, Button, Form, FormItem, Input, Radio, Card, FormItemGroup, htmlRender, Toggle, generateSlugify, Tooltip, AsumsiIcon } from 'asumsi-components';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ImgCrop from 'antd-img-crop';
import { IResponseLandingPage, IResponseLandingSection } from '@interfaces/iresponse-landing-page';

export const PageLandingPageFormComponent = (props: any) => {
    const { Option } = Select;
    // declare action and attribute needed
    const { isLoader, setFieldsValues, fieldsValues, handleSubmit, addSection, previewPages, editSection, topics, otherLanding, detail, idData, show } = props;

    const optionsTopics = topics ? topics.map((tp: any) => <Option key={tp.id} value={tp.id}>{tp.name}</Option>) : null;
    const optionsOtherLanding = otherLanding ? otherLanding.map((oth: any) => <Option key={oth.id} value={oth.id}>{oth.title}</Option>) : null;

    const dataDetail: IResponseLandingPage = detail;
    useEffect(() => {
        if (idData) {
            setFieldsValues({
                title: dataDetail.title,
                slug: dataDetail.slug,
                topicId: dataDetail.topicId,
                topicName: dataDetail.topicName,
                checkPointType: dataDetail.checkPointType,
                heroImageLargeUrl: dataDetail.heroImageLargeUrl,
                heroImageSmallUrl: dataDetail.heroImageSmallUrl,
                status: dataDetail.status == 'published' ? true : false,
                sections: dataDetail.sections,
                prevLandingPageId: dataDetail.prevLandingPage ? dataDetail.prevLandingPage.id : "",
                nextLandingPageId: dataDetail.nextLandingPage ? dataDetail.nextLandingPage.id : ""
            });
        }
    }, [detail]);

    const [fileList, setFileList] = useState([]);
    const [fileList2, setFileList2] = useState([]);

    function getBase64(file: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    const onChangeSmallImage = async ({ fileList: newFileList }: any) => {
        if (newFileList[0]) {
            const tumbnail = await getBase64(newFileList[0].originFileObj);
            newFileList[0].thumbUrl = tumbnail;
            newFileList[0].status = 'done';
        }
        setFileList(newFileList);
        setFieldsValues({ ...fieldsValues, heroImageSmall: newFileList[0] ? newFileList[0].originFileObj : null });
    };

    const onChangeLargeImage = async ({ fileList: newFileList }: any) => {
        if (newFileList[0]) {
            const tumbnail = await getBase64(newFileList[0].originFileObj);
            newFileList[0].thumbUrl = tumbnail;
            newFileList[0].status = 'done';
        }
        setFileList2(newFileList);
        setFieldsValues({ ...fieldsValues, heroImageLarge: newFileList[0] ? newFileList[0].originFileObj : null });
    };

    const beforeUploadHero1 = (file: any) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            notification.error({
                description: "You can only upload JPG/PNG file",
                duration: 5,
                message: 'Failed',
            });
            //   message.error('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            notification.error({
                description: "Image must smaller than 2MB!",
                duration: 5,
                message: 'Failed',
            });
            //   message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    }

    const onPreview = async (file: any) => {
        let src = file.url;
        if (!src) {
            src = await new Promise(resolve => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        if (imgWindow) {
            imgWindow.document.write(image.outerHTML);
        }
    };

    const emptyImage = (widthImage: string, heightImage: string, type: string) => <div className="empty-upload">
        <div>
            <p className="size">{`for ${type} screen, ${widthImage}x${heightImage}px`}</p>
            <p className="desc">Click to browse or drag file to this area to upload</p>
        </div>
    </div>;

    const onchangeRadio = (e: any) => {
        if (e.target.checked) {
            setFieldsValues({ ...fieldsValues, checkPointType: e.target.value });
        }
    }

    const contents = () => {
        return fieldsValues.sections && fieldsValues.sections.length > 0 ? fieldsValues.sections.sort((a: any, b: any) => a.orderNumber - b.orderNumber).map((sec: IResponseLandingSection, index: number) =>
            <Card className="display-contents m-t-20 m-b-20"><Card
                key={index} className="asumsi-card">
                <div className="tags">{fieldsValues.checkPointType == 2 ? <label className="m-r-20">Group Checkpoint: {sec.checkPointGroup || '-'}</label> : null} <label className="m-r-20">Checkpoint: {sec.checkPoint || "-"}</label> <label>Description: {sec.checkPointDesc || "-"}</label></div>
                <div className="display-flex">
                    <div className="se-wrapper-inner se-wrapper-wysiwyg sun-editor-editable display-sections">
                        {htmlRender(sec.content ?? '')}
                    </div>
                    <div className="action-tools">
                        <Tooltip text="edit">
                            <Button type="default" onClick={() => editSection({
                                checkPointGroup: sec.checkPointGroup,
                                checkPoint: sec.checkPoint,
                                checkPointDesc: sec.checkPointDesc,
                                content: sec.content,
                                frames: sec.frames,
                                orderNumber: sec.orderNumber
                            })}>
                                <AsumsiIcon icon="annotation" />
                            </Button>
                        </Tooltip>
                        <Tooltip text="hapus">
                            <Button type="default" onClick={() => {
                                const newData = fieldsValues.sections;
                                const index = newData.findIndex((element: IResponseLandingSection) => element.orderNumber == sec.orderNumber);
                                if (index >= 0) {
                                    newData.splice(index, 1);
                                }

                                setFieldsValues({ ...fieldsValues, sections: newData })
                            }}>
                                <AsumsiIcon icon="trash" />
                            </Button>
                        </Tooltip>
                    </div>
                </div>
            </Card></Card>) : null;
    }

    const onChangeName = (e: any) => {
        const val: string = e.target.value;
        const slug = generateSlugify(val);
        const errors = fieldsValues.errors;
        if (errors) {
            const index = errors.findIndex((element: string) => element == 'slug');
            if (index >= 0) {
                errors.splice(index, 1);
            }
        }

        if (!slug) {
            errors.push('slug');
        }

        setFieldsValues({ ...fieldsValues, errors, slug });
    }

    const defaultImage = (imageUrl: string, type: string) => {
        const onDeleteImage = () => {
            if (type == 'small') {
                setFieldsValues({ ...fieldsValues, heroImageSmall: null, heroImageSmallUrl: null });
            } else {
                setFieldsValues({ ...fieldsValues, heroImageLarge: null, heroImageLargeUrl: null });
            }

        }
        const pathUrl = imageUrl.split('/');
        return <div className="ant-upload-list ant-upload-list-picture">
            <div>
                <span>
                    <div className="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture">
                        <div className="ant-upload-list-item-info">
                            <span>
                                <a className="ant-upload-list-item-thumbnail" href={imageUrl} target="_blank" rel="noopener noreferrer">
                                    <img src={imageUrl} className="ant-upload-list-item-image"></img>
                                </a>
                                <span className="ant-upload-list-item-name ant-upload-list-item-name-icon-count-1" title="005940800_1552970791-fotoHL_kucing.jpg">
                                    {pathUrl[pathUrl.length - 1]}
                                </span>
                                <span className="ant-upload-list-item-card-actions picture">
                                    <a title="Remove file" onClick={onDeleteImage}>
                                        <i aria-label="icon: delete" title="Remove file" className="anticon anticon-delete">
                                            <svg viewBox="64 64 896 896" focusable="false" data-icon="delete" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                                <path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z">
                                                </path>
                                            </svg>
                                        </i>
                                    </a>
                                </span>
                            </span>
                        </div>
                    </div>
                </span>
            </div>
        </div>
    }

    const changeTopics = (value: string) => {
        setFieldsValues({ ...fieldsValues, topicId: value, errors: [] });
    }

    const changePrevPage = (value: string) => {
        setFieldsValues({ ...fieldsValues, prevLandingPageId: value, errors: [] });
    }

    const changeNextPage = (value: string) => {
        setFieldsValues({ ...fieldsValues, nextLandingPageId: value, errors: [] });
    }

    return (
        <Card className={`asumsi-card-form-shadow-rd-15 ${show ? '' : 'hidden'}`}>
            <Form titleBold>
                <Skeleton loading={isLoader}>
                    <FormItemGroup className="item-group">
                        <FormItem width="100%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Topic" labelAlign="left"
                            fieldDecorator={{
                                label: "topicId",
                                rules: [{
                                    message: 'Please select topic',
                                    required: true,
                                }
                                ]
                            }}
                        >
                            <Select
                                id="topicId"
                                showSearch
                                style={{ width: "400px" }}
                                onChange={changeTopics}
                                allowClear={false}
                                optionFilterProp="children"
                                value={fieldsValues.topicId}
                                defaultValue={fieldsValues.topicId}
                                placeholder="Please select topic">
                                {optionsTopics}
                            </Select>
                        </FormItem>
                        <FormItem width="100%" className="right" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} labelAlign="right"
                            fieldDecorator={{
                                label: "status"
                            }}
                        >
                            <div><span>Publish on save</span> <Toggle id="status" defaultChecked={fieldsValues.status} /></div>
                        </FormItem>
                    </FormItemGroup>
                    <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Title" labelAlign="left"
                        fieldDecorator={{
                            label: "title",
                            rules: [{
                                message: 'Please input title',
                                required: true,
                            }]
                        }}
                    >
                        <Input onChange={onChangeName} id="title" defaultValue={fieldsValues.title} />
                    </FormItem>
                    <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Slug" labelAlign="left"
                        fieldDecorator={{
                            label: "slug",
                            rules: [{
                                message: 'Please input slug',
                                required: true,
                            },
                            {
                                message: "Only alphanumeric and -",
                                pattern: /^[a-zA-Z0-9-]+$/,
                            }]
                        }}
                    >
                        <Input id="slug" defaultValue={fieldsValues.slug} />
                    </FormItem>
                    <FormItemGroup className="item-group" title="Hero Image">
                        <FormItem className="m-r-20 hero-image-small" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} labelAlign="left"
                            fieldDecorator={{
                                label: "heroImageSmall"
                            }}
                        >
                            {fieldsValues.heroImageSmallUrl ? defaultImage(fieldsValues.heroImageSmallUrl, 'small') :
                                <ImgCrop aspect={0.666666667} rotate>
                                    <Upload
                                        listType="picture"
                                        fileList={fileList}
                                        openFileDialogOnClick={true}
                                        onChange={onChangeSmallImage}
                                        onPreview={onPreview}
                                        beforeUpload={beforeUploadHero1}
                                    >
                                        {fileList.length == 0 && emptyImage("720", "1080", "small")}
                                    </Upload>
                                </ImgCrop>}

                        </FormItem>
                        <FormItem className="content-right hero-image" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} labelAlign="left"
                            fieldDecorator={{
                                label: "heroImageLarge",
                            }}
                        >
                            {fieldsValues.heroImageLargeUrl ? defaultImage(fieldsValues.heroImageLargeUrl, 'large') :
                                <ImgCrop aspect={1.777777778} rotate>
                                    <Upload
                                        listType="picture"
                                        fileList={fileList2}
                                        openFileDialogOnClick={true}
                                        onChange={onChangeLargeImage}
                                        onPreview={onPreview}
                                    >
                                        {fileList2.length == 0 && emptyImage("1920", "1080", "large")}
                                    </Upload>
                                </ImgCrop>}
                        </FormItem>
                    </FormItemGroup>
                    <FormItemGroup title="Timeline Type" className="item-group m-t-20 m-b-20">
                        <Radio className="m-r-10" id="checkPointType1"
                            checked={fieldsValues.checkPointType == 1}
                            value={1}
                            text="1 checkpoint timeline"
                            onChange={onchangeRadio} />
                        <Radio id="checkPointType2"
                            checked={fieldsValues.checkPointType == 2}
                            value={2}
                            text="2 checkpoint timeline"
                            onChange={onchangeRadio} />
                    </FormItemGroup>
                    <FormItemGroup className="item-group" title="Page Content" />
                    {contents()}
                    <Card className="asumsi-card m-t-20 m-b-20 center">
                        <Button size="medium" type="primary" iconLeft="plus" onClick={addSection} text="Add Section" />
                    </Card>
                    <FormItemGroup className="item-group" title="Other Landing Page">
                        <FormItem className="m-r-10" setFieldsValues={setFieldsValues} hideRequiredMark={true} fieldsValues={fieldsValues} labelAlign="left"
                            fieldDecorator={{
                                label: "prevLandingPageId"
                            }}
                        >
                            <Select
                                id="prevLandingPageId"
                                showSearch
                                style={{ width: "100%" }}
                                onChange={changePrevPage}
                                allowClear={false}
                                optionFilterProp="children"
                                value={fieldsValues.prevLandingPageId}
                                defaultValue={fieldsValues.prevLandingPageId}
                                placeholder="Please select other landing page">
                                {optionsOtherLanding}
                            </Select>

                        </FormItem>
                        <FormItem className="content-right" setFieldsValues={setFieldsValues} hideRequiredMark={true} fieldsValues={fieldsValues} labelAlign="left"
                            fieldDecorator={{
                                label: "nextLandingPageId"
                            }}
                        >
                            <Select
                                id="nextLandingPageId"
                                showSearch
                                style={{ width: "100%" }}
                                onChange={changeNextPage}
                                allowClear={false}
                                value={fieldsValues.nextLandingPageId}
                                defaultValue={fieldsValues.nextLandingPageId}
                                optionFilterProp="children"
                                placeholder="Please select other landing page">
                                {optionsOtherLanding}
                            </Select>
                        </FormItem>
                    </FormItemGroup>
                </Skeleton>
                <ButtonAction
                    left={
                        <Link to="/article/landing-page">
                            <Button type="outline-red" size="medium" disabled={isLoader} text="Cancel"></Button>
                        </Link>
                    }
                    right={
                        <div className="display-flex">
                            <Button className="m-r-5" width="120px" iconLeft="eye-open" type="outline-green" size="medium"
                                disabled={!fieldsValues.slug}
                                loading={isLoader} text="Preview" onClick={previewPages} />
                            <Button width="120px" type="green" size="medium"
                                disabled={fieldsValues.errors && fieldsValues.errors.length > 0}
                                loading={isLoader} onClick={handleSubmit} text={`${fieldsValues.status ? 'Publish' : 'Save'}`} />
                        </div>
                    }
                />
            </Form>
        </Card>
    );
};
export default PageLandingPageFormComponent;



// WEBPACK FOOTER //
// ./src/pages/landing-page-form/libraries/landingPageFrom.tsx